<template>
  <div data-testid="oc-self-service-step" class="h-100 bg-white p-4 pt-0 d-flex flex-column self-service-step">
    <OrderSettingsTab
      ref="settingsTab"
      data-testid="oc-self-service-settings-tab"
      :order-id="orderId"
      :order="order"
      :is-self-service="true"
      @update:allowNext="emit('update:allowNext', $event)" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import OrderSettingsTab from '@/components/orders/details/OrderSettingsTab.vue';
import { useOrderCreationStore } from '@/stores/orderCreation';

defineProps<{
  allowNext?: boolean;
}>();

const emit = defineEmits<{
  'update:allowNext': [value: boolean];
}>();

const route = useRoute();
const orderId = computed(() => route.query.orderId as string);

const orderStore = useOrderCreationStore();
const { order } = storeToRefs(orderStore);

const settingsTab = ref<InstanceType<typeof OrderSettingsTab> | null>(null);

const triggerNextProvider = () => {
  return settingsTab.value?.triggerNextProvider() || false;
};

const hasNextProvider = computed(() => {
  return settingsTab.value?.hasNextProvider ?? false;
});

const currentProviderValid = computed(() => {
  return settingsTab.value?.currentProviderValid ?? false;
});

defineExpose({
  triggerNextProvider,
  get hasNextProvider() {
    return hasNextProvider.value;
  },
  get currentProviderValid() {
    return currentProviderValid.value;
  },
});
</script>

<style scoped lang="scss">
/* sets the sticky offset for OrderSettingsTab's .preview-panel so it clears
   CreateOrderPageNew's sticky HeaderNavbar (≈167px on this page + some breathing room) */
.self-service-step {
  --settings-preview-top: 180px;
}

.header-area {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  height: 120px;
}
</style>
